import { LandingPage } from '@verantos-dev/el-feature-landing-page';
import { getUrlForSidebarAppId } from '@verantos-dev/shared-layout';

import { useVepSidebarConfig } from './useVepSidebarConfig';
import { useAllowedApps } from '../hooks/useAllowedApps';

/**
 * VEP-specific container for LandingPage.
 * Uses VEP-specific useAllowedApps hook to get allowed apps and passes them to the presentational LandingPage.
 */
export const VepLandingPage = () => {
  const sidebarConfig = useVepSidebarConfig();
  const apps = useAllowedApps();

  return (
    <LandingPage apps={apps} getUrl={(appId) => getUrlForSidebarAppId(sidebarConfig, appId)} />
  );
};
